module.exports = __webpack_public_path__ + "static/media/m_hairstyle_slickedback_front_vector.271b6304.svg";